module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulBlog":{"title":"Popes Visit to Knock ","slug":"popes-visit-to-knock","metaDescription":"Pope Francis soon to visit Knock ","body":{"childMarkdownRemark":{"html":"<p>Pope Francis will visit Knock Shrine in a few days time. This is a wonderful event for the West of Ireland and for all of us living here. </p>"}},"featuredImage":null}},"pathContext":{"slug":"popes-visit-to-knock"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-popes-visit-to-knock.json
// module id = 356
// module chunks = 63637368743341